import { callApi } from "../../utils/common.utils";
import { format } from "date-fns/format";

export const formatDate = (date?: Date, formatStr = "MM/dd/yyyy") => {
  return date ? format(date, formatStr) : "";
};

export const fetchBenchmarkScheduledJobs = async (userId: string) => {
 const payLoad = {
    id: userId,
  };
  return callApi("getScheduledJobs", payLoad, "getData");
};

export const fetchBenchmarkCompletedJobs = async (
  userId: string,
  startDate?: Date,
  endDate?: Date
) => {
  const newstartDate = formatDate(startDate);
  const newendDate = formatDate(endDate);
  const payLoad = {
    id: userId,
    startDate: newstartDate,
    endDate: newendDate,
  };
  return callApi("getCompletedJobs", payLoad, "getData");
};

export const fetchApprovalScheduled = async (approveId: number) => {
  const payLoad = {
    id: approveId,
  };
  return callApi("getApprovalScheduled", payLoad, "getData");
};

export const fetchBenchmarkProducts = async () => {
  const payLoad = {};
  return callApi("getBenchmarkProducts", payLoad, "getData");
};

export const updateSingleApprovalScheduled = async (
  approveId: number | null,
  estimatedYardage: string,
  notExceedYardage: string,
  overageApprovedBy: string,
  dateOverageApproved?: Date
) => {
  const newDateOverageApproved = formatDate(dateOverageApproved);
  const payLoad = {
    id: approveId,
    estimatedyardage: estimatedYardage,
    notexceedyardage: notExceedYardage,
    overageapprovedby: overageApprovedBy,
    dateoverageapproved: newDateOverageApproved,
  };
  return callApi("updateApprovalScheduled", payLoad, "updateData");
};
export const fetchRequestedChangeScheduled = async (userId: number) => {
  const payLoad = {
    id: userId,
  };
  return callApi("getRequestedChangeScheduled", payLoad, "getData");
};

export const updateSingleRequestedChangeScheduled = async (
  userId: number | null,
  requestedYardage: string,
  requestedProduct: string,
  note: string,
  requestedDeliveryDate?: Date,
  sensitiveClient?: number
) => {
  const newRequestedDeliveryDate = formatDate(requestedDeliveryDate);
  const newDateChangeRequested = formatDate(new Date());

  const payLoad = {
    id: userId,
    requesteddeliverydate: newRequestedDeliveryDate,
    requestedyardage: requestedYardage,
    requestedproduct: requestedProduct,
    note: note,
    datechangerequested: newDateChangeRequested,
    sensitiveclient: sensitiveClient,
  };
  return callApi("updateRequestedChangeScheduled", payLoad, "updateData");
};

export const fetchMapScheduled = async (userId: number) => {
  const payLoad = {
    id: userId,
  };
  return callApi("getMapScheduled", payLoad, "getData");
};

export const updateSingleMapScheduled = async (
  userId: number | null,
  companyRequestChange: string
) => {
  const payLoad = {
    id: userId,
    companyrequestchange: companyRequestChange,
  };
  return callApi("updateMapScheduled", payLoad, "updateData");
};
